export default __webpack_public_path__ + "static/media/r3.158e9ce1.png";